import { Pow18 } from 'config'
import { Ether } from 'types'
import { e2w } from 'utils/number'
import {
  calcTradingFeeRate,
  TradingFeeRate,
  TradingFeeStatus,
} from 'utils/valuation/calcTradingFeeRate'

export function useTradingFeeRate(
  price: Ether,
  amount: Ether,
  minMaker: number = 0,
  minTaker: number = 0,
): TradingFeeRate {
  // return useMemo(() => {
  //   return getTradingFeeRate(price, amount, minMaker, minTaker)
  // }, [price, amount, minMaker, minTaker])

  return {
    maker: minMaker,
    taker: minTaker,
    status: TradingFeeStatus.Normal,
  }
}

export function getTradingFeeRate(
  price: Ether,
  amount: Ether,
  minMaker: number = 0,
  minTaker: number = 0,
): TradingFeeRate {
  if (!price) {
    price = '0'
  }
  if (!amount) {
    amount = '0'
  }
  return calcTradingFeeRate(
    e2w(price).mul(e2w(amount)).div(Pow18),
    minMaker,
    minTaker,
  )
}
